/**
 * This utility is here to push a copy of the current state into history.  We do this because the only event we can
 * catch indicating that the user has hit back is the popstate event which is fired after a pop, not before.  As such
 * the strategy is to make a copy of the current history and then catch pop and ask the user if they really want to
 * leave.  If the answer is yes then we call history.back in code a second time to take them where they want to go.
 */
// TODO deprecate this once routing is brought into this repo
export const pushEmptyState = (): void => window.history.pushState(null, "", window.location.href);
